import { getTypography, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import styled, { css } from 'styled-components';
import { Variant, VariantComponent } from './productOfferCard.model';

const resh = {
  wrapPill: css``,
  title: css`
    ${getTypography('h3.extrabold')}
    margin: ${pxToRem(0, 0, 24, 0)};
  `,
  info: css`
    margin: ${pxToRem(16, 0, 0, 0)};
    ${getTypography('body3.regular')}
  `,
};

const onb = {
  wrapPill: css`
    margin: ${pxToRem(0, 0, 16, 0)};
  `,
  title: css`
    font-weight: 300;
    ${pxToCssFont(24, 32)}
    margin: ${pxToRem(0, 0, 16, 0)};
  `,
  info: css`
    margin: ${pxToRem(16, 0, 0, 0)};
    font-weight: 400;
    ${pxToCssFont(18, 24)}
  `,
};

export const getVariant = (component: VariantComponent, variant?: Variant) => {
  switch (variant) {
    case 'resh':
      return resh[component];
    default:
      return onb[component];
  }
};

export const Title = styled.h2<{ variant: Variant }>`
  ${({ variant }) => getVariant('title', variant)}
`;

export const TextPill = styled.h3`
  ${getTypography('body1.bold')}
  margin:0;
`;

export const WrapPill = styled.h3<{ variant: Variant }>`
  width: fit-content;
  ${({ variant }) => getVariant('wrapPill', variant)}
`;

export const Info = styled.div<{ variant: Variant }>`
  p {
    margin: 0;
  }

  ${({ variant }) => getVariant('info', variant)}
`;
